'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UserPanel = require('../components/UserPanel');

var _UserPanel2 = _interopRequireDefault(_UserPanel);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

var _UserContent = require('../components/UserContent');

var _UserContent2 = _interopRequireDefault(_UserContent);

var _UserEdit = require('../components/UserEdit');

var _UserEdit2 = _interopRequireDefault(_UserEdit);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var User = function (_Component) {
  _inherits(User, _Component);

  function User() {
    _classCallCheck(this, User);

    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
  }

  _createClass(User, [{
    key: 'renderMissing',
    value: function renderMissing() {
      var _props$user = this.props.user,
          askedUsername = _props$user.askedUsername,
          id = _props$user.id;

      return _react2.default.createElement(
        _NavApp2.default,
        { title: 'Missing Profile' },
        _react2.default.createElement(
          'div',
          { className: 'dummy-page bad-link' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'supermessage' },
              'bad link'
            ),
            _react2.default.createElement(
              'div',
              { className: 'message' },
              'Missing profile for ',
              _react2.default.createElement(
                'span',
                null,
                askedUsername || id
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'submessage' },
              'This user does not exist or they chose not to publish their profile.'
            )
          )
        )
      );
    }
  }, {
    key: 'renderUser',
    value: function renderUser() {
      var _props$user2 = this.props.user,
          pending = _props$user2.pending,
          fail = _props$user2.fail,
          staged = _props$user2.staged;

      if (pending) {
        return _react2.default.createElement(_UILoadingSpinner2.default, { grow: true, minHeight: 400 });
      }
      if (fail) {
        return this.renderMissing();
      }
      var content = staged ? _react2.default.createElement(_UserEdit2.default, null) : _react2.default.createElement(_UserContent2.default, null);
      return _react2.default.createElement(
        'div',
        { className: 'user-page' },
        _react2.default.createElement(_UserPanel2.default, null),
        content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$user3 = this.props.user,
          firstName = _props$user3.firstName,
          lastName = _props$user3.lastName,
          askedUsername = _props$user3.askedUsername,
          id = _props$user3.id;

      var title = firstName || lastName ? (firstName + ' ' + lastName).trim() : askedUsername || 'User Profile ' + id;
      return _react2.default.createElement(
        _NavApp2.default,
        { title: title },
        this.renderUser()
      );
    }
  }]);

  return User;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;

  return { user: user };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(User);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/User.js
// module id = 196
// module chunks = 177